import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MicrophoneOff02 = function MicrophoneOff02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 12v1c0 4.4183 3.5817 8 8 8 2.4653 0 4.6701-1.1151 6.1376-2.8684M2 2l20 20m-6-11.6V7c0-2.2091-1.7909-4-4-4a3.984 3.984 0 0 0-2.5291.9009M12 17c-2.2091 0-4-1.7909-4-4V8l7.2815 7.288C14.5585 16.323 13.3583 17 12 17"
    })
  }));
};
export default MicrophoneOff02;